import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileTextRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.3 5.4h5.9V10c0 2 1.6 3.7 3.7 3.7h4.6v12.2q-.1.7-.8.8H9.3a1 1 0 0 1-.8-.9V6.4q.1-.8.8-.9m8.4 1 4.8 4.7h-3.6q-1.1 0-1.2-1.2zM9.3 3A3.3 3.3 0 0 0 6 6.3v19.5C6 27.5 7.5 29 9.3 29h13.4c1.8 0 3.3-1.5 3.3-3.2V12.5q0-1.4-1-2.3l-6.4-6.3q-1-.9-2.3-.9zm3 13Q11 16 11 17.2q.1 1.1 1.3 1.2h7.5q1 0 1.2-1.2-.2-1.1-1.2-1.2zm0 4.9Q11 20.9 11 22q.1 1.1 1.3 1.2h7.5q1 0 1.2-1.2-.2-1.1-1.2-1.2z" })
});
export default SvgFileTextRegularIcon;
